(() => {
  const script = document.currentScript;
  const requestLocale = (script?.dataset.crawfordRequestLocale || '').toLowerCase().split('-')[0];
  const country = (script?.dataset.crawfordCountry || '').toUpperCase();

  const dictionaries = {
    nl: {
      'Choose color': 'Kies de kleur',
      'Belt #1': 'Riem #1',
      'Belt #2': 'Riem #2',
      'Color': 'Kleur',
      'Black': 'Zwart',
      'Brown': 'Bruin',
      'Add free personalization': 'Gratis personalisatie toevoegen',
      'Add personalization': 'Personalisatie toevoegen',
      'Initials': 'Initialen',
      'Maximum 4 characters': 'Maximaal 4 tekens',
      'Engraving position': 'Positie gravure',
      'Outer': 'Buitenkant',
      'Inner': 'Binnenkant',
      'Preview': 'Voorbeeld',
      'The same initials will be applied to both belts.': 'Dezelfde initialen worden op beide riemen toegepast.',
      'Outer engraving': 'Gravure aan de buitenkant',
      'Inner engraving': 'Gravure aan de binnenkant',
      'Add to cart': 'Toevoegen aan winkelwagen',
      'ADD TO CART': 'TOEVOEGEN AAN WINKELWAGEN',
      'Size Guide': 'Maattabel',
      'SIZE GUIDE': 'MAATTABEL',
      'Delivery and Returns': 'Levering en retourneren',
      'DELIVERY AND RETURNS': 'LEVERING EN RETOURNEREN'
    },
    es: {
      'Choose color': 'Elige el color',
      'Belt #1': 'Cinturón #1',
      'Belt #2': 'Cinturón #2',
      'Color': 'Color',
      'Black': 'Negro',
      'Brown': 'Marrón',
      'Add free personalization': 'Añadir personalización gratuita',
      'Add personalization': 'Añadir personalización',
      'Initials': 'Iniciales',
      'Maximum 4 characters': 'Máximo 4 caracteres',
      'Engraving position': 'Posición del grabado',
      'Outer': 'Exterior',
      'Inner': 'Interior',
      'Preview': 'Vista previa',
      'The same initials will be applied to both belts.': 'Las mismas iniciales se aplicarán a ambos cinturones.',
      'Outer engraving': 'Grabado exterior',
      'Inner engraving': 'Grabado interior',
      'Add to cart': 'Añadir a la cesta',
      'ADD TO CART': 'AÑADIR A LA CESTA',
      'Size Guide': 'Guía de tallas',
      'SIZE GUIDE': 'GUÍA DE TALLAS',
      'Delivery and Returns': 'Envíos y devoluciones',
      'DELIVERY AND RETURNS': 'ENVÍOS Y DEVOLUCIONES'
    },
    fr: {
      'Choose color': 'Choisissez la couleur',
      'Belt #1': 'Ceinture #1',
      'Belt #2': 'Ceinture #2',
      'Color': 'Couleur',
      'Black': 'Noir',
      'Brown': 'Marron',
      'Add free personalization': 'Ajouter la personnalisation gratuite',
      'Add personalization': 'Ajouter la personnalisation',
      'Initials': 'Initiales',
      'Maximum 4 characters': '4 caractères maximum',
      'Engraving position': 'Position de la gravure',
      'Outer': 'Extérieur',
      'Inner': 'Intérieur',
      'Preview': 'Aperçu',
      'The same initials will be applied to both belts.': 'Les mêmes initiales seront appliquées aux deux ceintures.',
      'Outer engraving': 'Gravure extérieure',
      'Inner engraving': 'Gravure intérieure',
      'Add to cart': 'Ajouter au panier',
      'ADD TO CART': 'AJOUTER AU PANIER',
      'Size Guide': 'Guide des tailles',
      'SIZE GUIDE': 'GUIDE DES TAILLES',
      'Delivery and Returns': 'Livraison et retours',
      'DELIVERY AND RETURNS': 'LIVRAISON ET RETOURS'
    }
  };

  function inferLanguage() {
    const pathMatch = window.location.pathname.match(/^\/(nl|es|fr)(?:\/|$)/i);
    if (pathMatch) return pathMatch[1].toLowerCase();

    const htmlLang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    if (dictionaries[htmlLang]) return htmlLang;

    if (dictionaries[requestLocale]) return requestLocale;

    if (country === 'NL' || country === 'BE') return 'nl';
    if (country === 'ES') return 'es';
    if (country === 'FR') return 'fr';

    // T Lab / third-party apps can translate parts of the page client-side
    // while Shopify's request locale remains English. Detect the Dutch UI
    // that is already visible and keep the custom Crawford controls in sync.
    const text = document.body?.innerText || '';
    if (/\bJe bespaart\b/i.test(text) || /\bper riem\b/i.test(text) || /\bgeld-terug-garantie\b/i.test(text)) {
      return 'nl';
    }

    return '';
  }

  function replaceExactText(root, dictionary) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    let node;
    while ((node = walker.nextNode())) nodes.push(node);

    for (const textNode of nodes) {
      const raw = textNode.nodeValue || '';
      const trimmed = raw.trim();
      const translated = dictionary[trimmed];
      if (!translated || translated === trimmed) continue;
      const leading = raw.match(/^\s*/)?.[0] || '';
      const trailing = raw.match(/\s*$/)?.[0] || '';
      textNode.nodeValue = `${leading}${translated}${trailing}`;
    }
  }

  function applyTranslations() {
    const lang = inferLanguage();
    const dictionary = dictionaries[lang];
    if (!dictionary) return;

    document.querySelectorAll([
      '.crawford-personalization',
      'buy-buttons',
      'product-sticky-bar',
      '.accordion__toggle'
    ].join(',')).forEach((root) => replaceExactText(root, dictionary));
  }

  let queued = false;
  function queueApply() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      applyTranslations();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueApply, { once: true });
  } else {
    queueApply();
  }

  const observer = new MutationObserver(queueApply);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['lang']
  });
})();
